import { setTitleByPathname } from '@/utils/title'
import { isSingleAppDomain, getAppConfig } from '@/utils/singleApp'

const { defaultSettings } = PROJECT_CONFIG

const title = defaultSettings.title

const SettingModel = {
    namespace: 'settings',
    state: {
        ...defaultSettings,
        title
    },
    reducers: {
        changeSetting(state = defaultSettings, { payload }) {
            const { contentWidth, } = payload

            if (state.contentWidth !== contentWidth && window.dispatchEvent) {
                window.dispatchEvent(new Event('resize'))
            }



            return { ...state, ...payload }
        }
    },
    subscriptions: {
        setup({ dispatch, history }) {
            if (isSingleAppDomain) {
                dispatch({
                    type: 'changeSetting',
                    payload: getAppConfig()
                })

                const { pathname } = history.location
                setTitleByPathname(pathname)
            }
        }
    }
}
export default SettingModel
